var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:{
        icon: true,
        'icon--xxs' : _vm.size === 'xxs',
        'icon--xs' : _vm.size === 'xs',
        'icon--sm' : _vm.size === 'sm',
        'icon--md' : _vm.size === 'md',
        'icon--xl' : _vm.size === 'xl',
    },on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529974b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/eventGrid/components/MarketIcon.vue
// module id = 1946
// module chunks = 0